{
    "component-card-search-list.empty-state.title.non-final": "<strong>Associez ce dépôt à un composant logiciel</strong>",
    "component-card.add-chat-channel": "Ajouter un canal de chat",
    "component-card.chat-channels": "Canaux de chat",
    "component-card.expander.show-more-link": "Afficher {formattedCount} de plus"
}
